var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5813 1.82996C10.8308 1.89622 11.0398 2.06642 11.1553 2.29732C11.5905 3.16773 11.9153 3.696 12.2421 4.12432C12.5728 4.55788 12.9227 4.91281 13.455 5.44506C14.6849 6.67503 15.3002 8.28892 15.3002 9.89984C15.3002 11.5108 14.6849 13.1246 13.455 14.3546C10.9947 16.8149 7.00572 16.8149 4.54542 14.3546C3.31545 13.1246 2.7002 11.5108 2.7002 9.89984C2.70019 8.28892 3.31545 6.67503 4.54542 5.44506C4.80282 5.18766 5.18993 5.11066 5.52623 5.24996C5.86254 5.38926 6.08182 5.71744 6.08182 6.08145C6.08182 7.08928 6.14475 7.85722 6.43952 8.46974C6.60161 8.80655 6.85446 9.13584 7.29024 9.42968C7.39431 8.47499 7.58496 7.31184 7.84257 6.2078C8.04539 5.33856 8.29765 4.47076 8.59789 3.7471C8.74807 3.38514 8.91789 3.04049 9.11076 2.74292C9.2985 2.45327 9.5397 2.15853 9.85105 1.95096C10.0658 1.80777 10.3318 1.7637 10.5813 1.82996ZM10.9094 13.609C9.85497 14.6634 8.14542 14.6634 7.09101 13.609C6.5638 13.0818 6.3002 12.3908 6.3002 11.6998C6.3002 11.6998 7.09101 12.1498 8.55024 12.1498C8.55024 11.2498 9.00024 8.5498 9.67524 8.0998C10.1252 8.9998 10.3822 9.26342 10.9094 9.79062C11.4366 10.3178 11.7002 11.0088 11.7002 11.6998C11.7002 12.3908 11.4366 13.0818 10.9094 13.609Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b82bc825fbb1a6d81d54beb4e4e03333.svg";
export { ForwardRef as ReactComponent };